export class Votacion {
  public idVoto: number = Math.floor(0);
  public idAsamblea: number = Math.floor(0);
  public idFoto: number = Math.floor(0);
  public idPregunta: number = Math.floor(0);
  public idOpcion: number = Math.floor(0);
  public voto = '';
  public usuarioRegistro = '';
  public peso = '';
  public token = '';
  public orden: number =0;
}
